document.addEventListener("DOMContentLoaded", () => {

    const content = document.getElementById("assistant-content");
    const answers = {

            goal: "",
            recipient: "",
            emotion: "",
            story: "",
            corporateRange: "",
            corporateProducts: [],
            customizations: [],
            inspiration: "",
            deadline: "",
            deadlineDate: "",
            budget: "",
            name: "",
            contactName: "",
            email: "",
            phone: ""

            };

    let currentScreen = "welcome";
    let editingSection = null;
    let browserNavigation = false;

    const previousScreen = {
        question1: "welcome",
        productType: "question1",
        recipient: "productType",
        emotion: "recipient",
        corporateRange: "emotion",
        corporateProducts: "corporateRange",
        story: "emotion",
        deadline: "story",
        customizations: "deadline",
        inspiration: "customizations",
        budget: "inspiration",
        contacts: "budget",
        summary: "contacts"
    };

    const recipientData = {

            gift: {
                title: "Per chi sarà destinata questa creazione?",
                options: [
                { value: "woman", label: "👩 Donna" },
                { value: "man", label: "👨 Uomo" },
                { value: "child", label: "🧒 Bambino" },
                { value: "couple", label: "💑 Coppia" },
                { value: "family", label: "👨‍👩‍👧 Famiglia" },
                { value: "teacher", label: "🍎 Insegnante" },
                { value: "other", label: "✨ Altro" }
                ]
            },

            event: {
                title: "Quale occasione vuoi rendere speciale?",
                options: [
                { value: "wedding", label: "💍 Matrimonio" },
                { value: "baptism", label: "👶 Battesimo" },
                { value: "communion", label: "🙏 Comunione" },
                { value: "birthday", label: "🎂 Compleanno" },
                { value: "anniversary", label: "❤️ Anniversario" },
                { value: "retirement", label: "🌿 Pensionamento" },
                { value: "other", label: "✨ Altro" }
                ]
            },

            home: {
                title: "Cosa immagini per la tua casa?",
                options: [
                { value: "painting", label: "🖼️ Quadro" },
                { value: "board", label: "🪵 Tagliere" },
                { value: "clock", label: "🕒 Orologio" },
                { value: "decoration", label: "🏡 Decorazione" },
                { value: "sign", label: "📜 Targa" },
                { value: "other", label: "✨ Altro" }
                ]
            },

            pet: {
                title: "Per quale animale?",
                options: [
                { value: "dog", label: "🐶 Cane" },
                { value: "cat", label: "🐱 Gatto" },
                { value: "horse", label: "🐴 Cavallo" },
                { value: "rabbit", label: "🐰 Coniglio" },
                { value: "other", label: "✨ Altro" }
                ]
            },

            };

    const emotionData = {

    title: "Che emozione vorresti trasmettere?",

    options: [

        { value: "love", label: "❤️ Amore" },

        { value: "joy", label: "😊 Gioia" },

        { value: "gratitude", label: "🤍 Gratitudine" },

        { value: "elegance", label: "✨ Eleganza" },

        { value: "serenity", label: "🌿 Serenità" },

        { value: "fun", label: "🎉 Divertimento" },

        { value: "other", label: "💭 Non lo so ancora" }

    ]

};

const corporateRanges = {

    essential: {
        label: "ESSENTIAL",
        subtitle: "Piccoli gesti, grande personalizzazione",
        description: "Idee semplici e curate, ideali per piccoli omaggi aziendali.",
        presentationImage: "https://cdn.shopify.com/s/files/1/1001/8258/9785/files/IMG_LINEA_ESSENTIAL.png?v=1788508886",
        products: [
            "Calamita in legno",
            "Portachiavi in legno",
            "Segnalibro in legno",
            "Segnalibro in metallo sublimabile",
            "Sottobicchiere in sughero",
            "Apribottiglie"
        ]
    },

    classic: {
        label: "CLASSIC",
        subtitle: "Idee regalo utili e personalizzate",
        description: "Oggetti più importanti per valorizzare il tuo brand con eleganza.",
        presentationImage: "https://cdn.shopify.com/s/files/1/1001/8258/9785/files/IMG_LINEA_CLASSIC.png?v=1788508887",
        products: [
            "Targa da appendere",
            "Tagliere in balsa",
            "Scatola piccola in legno",
            "Svuotatasche in legno",
            "Tazza sublimata",
            "Supporto telefono in bambù"
        ]
    },

    prestige: {
        label: "PRESTIGE",
        subtitle: "Composizioni che lasciano il segno",
        description: "Composizioni coordinate e personalizzate per un regalo speciale.",
        presentationImage: "https://cdn.shopify.com/s/files/1/1001/8258/9785/files/IMG_LINEA_PRESTIGE.png?v=1788509111",
        products: [
            "Tagliere in bambù inciso",
            "Composizione aperitivo",
            "Lampada in plexiglass + base in legno",
            "Pannello singolo in plexiglass con base in legno",
            "Composizione con statuina in resina",
            "Mini composizione con decorazione in resina",
            "Composizione regalo"
        ]
    },

    premium: {
        label: "PREMIUM",
        subtitle: "Creazioni importanti per sorprendere",
        description: "Regali di grande presenza, pensati per occasioni e destinatari speciali.",
        presentationImage: "https://cdn.shopify.com/s/files/1/1001/8258/9785/files/IMG_LINEA_PREMIUM.png?v=1788508886",
        products: [
            "Tagliere grande e spesso",
            "Scatola grande in legno",
            "Vassoio grande decorato",
            "Specchio inciso a mano",
            "Orologio da parete personalizzato",
            "Composizione Premium su progetto"
        ]
    }

};

const deadlineData = {

    title: "Quando ti servirebbe?",

    options: [

        {
            value: "urgent",
            label: "⚡ Il prima possibile"
        },

        {
            value: "week",
            label: "📅 Entro una settimana"
        },

        {
            value: "month",
            label: "🗓️ Entro un mese"
        },

        {
            value: "date",
            label: "📆 Ho una data precisa"
        },

        {
            value: "flexible",
            label: "🌿 Non ho fretta"
        }

    ]

};

const customizationOptions = [

    { value: "name", label: "👤 Nome" },

    { value: "date", label: "📅 Data" },

    { value: "dedication", label: "💌 Dedica" },

    { value: "photo", label: "🖼️ Foto" },

    { value: "logo", label: "🏷️ Logo" },

    { value: "colors", label: "🎨 Colori preferiti" },

    { value: "other", label: "✨ Altro" }

];


const customizationsData = {

    title: "✨ Quali personalizzazioni desideri aggiungere?",

    subtitle: "Puoi selezionarne anche più di una oppure nessuna."

};

const inspirationOptions = [
    { value: "mare", label: "🌊 Mare", image: "https://cdn.shopify.com/s/files/1/1001/8258/9785/files/mediterranean_sea.avif?v=1786968298" },
    { value: "natura", label: "🌿 Natura", image: "https://cdn.shopify.com/s/files/1/1001/8258/9785/files/nature_forest.avif?v=1786968299" },
    { value: "animali", label: "🐾 Animali", image: "https://cdn.shopify.com/s/files/1/1001/8258/9785/files/animals.avif?v=1786968298" },
    { value: "fiori", label: "🌸 Fiori", image: "https://cdn.shopify.com/s/files/1/1001/8258/9785/files/flower.avif?v=1786968297" },
    { value: "montagna", label: "🏔️ Montagna", image: "https://cdn.shopify.com/s/files/1/1001/8258/9785/files/alps_mountain.avif?v=1786968298" },
    { value: "vino", label: "🍷 Vino", image: "https://cdn.shopify.com/s/files/1/1001/8258/9785/files/wine_vineyard.avif?v=1786968298" },
    { value: "birra", label: "🍺 Birra", image: "https://cdn.shopify.com/s/files/1/1001/8258/9785/files/craft_beer.avif?v=1786968298" },
    { value: "musica", label: "🎵 Musica", image: "https://cdn.shopify.com/s/files/1/1001/8258/9785/files/music_instruments.avif?v=1786968297" },
    { value: "cucina", label: "🍳 Cucina", image: "https://cdn.shopify.com/s/files/1/1001/8258/9785/files/italian_cooking.avif?v=1786968298" },
    { value: "viaggi", label: "✈️ Viaggi", image: "https://cdn.shopify.com/s/files/1/1001/8258/9785/files/travel_landscape.avif?v=1786968298" },
    { value: "altro", label: "✨ Altro", image: "https://cdn.shopify.com/s/files/1/1001/8258/9785/files/altro.avif?v=1786968297" },
    { value: "non_so", label: "💭 Non ho ancora un'idea", image: "https://cdn.shopify.com/s/files/1/1001/8258/9785/files/senza_idee.avif?v=1786968297" }
];

const screens = {

        welcome: {
            progress: 0,
            html: `
                <div class="assistant-emoji">👋</div>

                <h1>Iniziamo a progettare insieme</h1>

                <p class="assistant-intro">
                    Ogni creazione nasce da un'idea, un ricordo o un'emozione.
                </p>

                <p>
                    Ti guiderò con alcune semplici domande per capire meglio il tuo progetto.
                    Non serve avere già tutto deciso: troveremo insieme la soluzione più adatta.
                </p>

                <button id="assistant-start" class="assistant-button">
                    Iniziamo
                </button>

                <p class="assistant-time">
                    ⏱ Circa 2 minuti
                </p>
            `
        },

        question1: {
            progress: 20,
            html: `
                <h2>Per cosa stai cercando una creazione?</h2>

                <p class="assistant-intro">
                    Scegli l'opzione che descrive meglio quello che hai in mente.
                </p>

                <div class="assistant-options">

                    <button class="assistant-card" data-value="gift">
                        <span>🎁</span>
                        <strong>Un regalo</strong>
                        <small>Per una persona speciale</small>
                    </button>

                    <button class="assistant-card" data-value="event">
                        <span>💍</span>
                        <strong>Un evento</strong>
                        <small>Bomboniere e ricordi</small>
                    </button>

                    <button class="assistant-card" data-value="home">
                        <span>🏡</span>
                        <strong>Per la casa</strong>
                        <small>Decorazioni personalizzate</small>
                    </button>

                    <button class="assistant-card" data-value="pet">
                        <span>🐾</span>
                        <strong>Per un animale</strong>
                        <small>Creazioni dedicate</small>
                    </button>

                    <button class="assistant-card" data-value="business">
                        <span>💼</span>
                        <strong>Per la mia attività</strong>
                        <small>Decorazioni e gadget</small>
                    </button>

                    <button class="assistant-card" data-value="other">
                        <span>✨</span>
                        <strong>Ho un'altra idea</strong>
                        <small>Raccontamela</small>
                    </button>

                </div>
            `
        },
    productType: {
    progress: 30,
    html: ""
    },
    recipient: {
        progress: 40,
            html: ""
    },
    
    emotion: {
        progress: 60,
        html: ""
    },

    corporateRange: {
        progress: 70,
        html: ""
    },

    corporateProducts: {
        progress: 75,
        html: ""
    },

    story: {
    progress: 80,
    html: `
        <h2>Raccontami la tua idea</h2>

        <p class="assistant-intro">
            Descrivimi la tua idea.
        </p>

        <textarea
            id="assistant-story"
            class="assistant-textarea"
            placeholder="Scrivi qui..."
        ></textarea>

        <button id="story-next" class="assistant-button">
            Continua
        </button>
    `
    },
    deadline: {
        progress: 80,
        html: ""
    },

    customizations: {
        progress: 90,
        html: ""
    },

    inspiration: {
        progress: 95,
        html: `
        <button id="assistant-back" class="assistant-back">
            ← Indietro
        </button>

        <h2>✨ Lasciati ispirare</h2>

        <p class="assistant-intro">
            Guarda qualche esempio e scegli ciò che ti piace di più.
            Le immagini sono solo ispirazioni: la tua creazione sarà progettata appositamente per te.
        </p>

        <div id="inspiration-list" class="assistant-options">
        </div>

        <button
            id="inspiration-next"
            class="assistant-button">
            Continua
        </button>
    `
    },

    budget: {
        progress: 97,
        html: ""
    },

    contacts: {
        progress: 98,
        html: ""
    },

    summary: {
        progress: 100,
        html: ""
    },

    };

    function updateProgress(value) {

    const progressBar = document.querySelector(".assistant-progress-fill");

    if (!progressBar) return;

    progressBar.style.width = value + "%";

    }

    function activateCards(answerKey, nextScreen) {

        const cards = document.querySelectorAll(".assistant-card");

     cards.forEach(card => {
        if (card.dataset.value === answers[answerKey]) {
        card.classList.add("selected");
     }
     });

        cards.forEach(card => {

     card.addEventListener("click", () => {

        const value = card.dataset.value;
        const deadlineExtra = document.getElementById("deadline-extra");

        if (deadlineExtra) {
            deadlineExtra.innerHTML = "";
        }

        const customizationsExtra = document.getElementById("customizations-extra");

        if (customizationsExtra) {
            customizationsExtra.innerHTML = "";
        }

        answers[answerKey] = value;

        if (answerKey === "goal" && value === "other") {
            setTimeout(() => {
            showScreen("story");
        }, 300);

        return;
     }


        if (answerKey === "deadline" && value === "date") {

        const extra = document.getElementById("deadline-extra");

        extra.innerHTML = `
        <div class="assistant-deadline-box">

            <label for="assistant-deadline-date">
                Seleziona la data
            </label>

            <input
                type="date"
                id="assistant-deadline-date"
                class="assistant-input"
            >

            <button
                id="deadline-next"
                class="assistant-button"
            >
                Continua
            </button>

        </div>
        `;

        document
        .getElementById("deadline-next")
        .addEventListener("click", () => {

        answers.deadlineDate =
            document.getElementById("assistant-deadline-date").value;

        console.log(answers);

        if (editingSection) {

            editingSection = null;
            showScreen("summary");

        } else {

            showScreen("customizations");

        }

     });

        return;

        }




        console.log(answers);
        cards.forEach(c => c.classList.remove("selected"));

        card.classList.add("selected");

        setTimeout(() => {

            if (editingSection) {

                editingSection = null;

                showScreen("summary");

            } else {

                showScreen(nextScreen);

            }

        }, 300);

        });

        });

     }

        function renderCards({
        title,
        subtitle,
        options,
        answerKey,
        nextScreen,
        extraContent = ""
        }) {

        content.innerHTML = `
        ${currentScreen !== "question1" ? `
            <button id="assistant-back" class="assistant-back">
                <span>←</span>
                <span>Torna indietro</span>
            </button>
        ` : ""}

        <h2>${title}</h2>

        <p class="assistant-intro">${subtitle}</p>

        <div class="assistant-options">
            ${options.map(option => `
                <button class="assistant-card" data-value="${option.value}">
                    ${option.label}
                </button>
            `).join("")}
        </div>
        ${extraContent}
        `;

        // QUI
        const backButton = document.querySelector(".assistant-back");

        if (backButton) {
            backButton.addEventListener("click", goBack);
        }

     activateCards(answerKey, nextScreen);

    }

    function showCustomizations() {

    content.innerHTML = `
        <button id="assistant-back" class="assistant-back">
            ← Indietro
        </button>

        <h2>✨ Quali personalizzazioni desideri aggiungere?</h2>

        <p class="assistant-intro">
            Puoi selezionarne anche più di una oppure nessuna.
        </p>

        <div class="assistant-options" id="customizations-list">

            ${customizationOptions.map(option => `
                <button
                    type="button"
                    class="assistant-card customization-card"
                    data-value="${option.value}">
                    ${option.label}
                </button>
            `).join("")}

        </div>

        <div id="customization-details"></div>

        <button
            type="button"
            id="customizations-next"
            class="assistant-button">
            Continua
        </button>
        `;

        updateProgress(screens.customizations.progress);

        document
        .getElementById("assistant-back")
        .addEventListener("click", goBack);

        const selected = [];

         document
        .querySelectorAll(".customization-card")
        .forEach(card => {

            card.addEventListener("click", () => {

                const value = card.dataset.value;

                card.classList.toggle("selected");

                const detailsContainer =
                    document.getElementById("customization-details");

                if (!detailsContainer) return;


                /* ==========================
                   NOME
                ========================== */

                if (
                    card.classList.contains("selected") &&
                    value === "name"
                ) {

                    if (!document.getElementById("customization-name")) {

                        detailsContainer.insertAdjacentHTML("beforeend", `
                            <div class="customization-detail">

                                <label for="customization-name">
                                    Quale nome vuoi inserire?
                                </label>

                                <input
                                    type="text"
                                    id="customization-name"
                                    class="assistant-input"
                                    placeholder="Scrivi il nome..."
                                >

                            </div>
                        `);

                    }

                } else if (value === "name") {

                    const field =
                        document.getElementById("customization-name");

                    if (field) {
                        field.parentElement.remove();
                    }

                }


                /* ==========================
                   DATA
                ========================== */

                if (
                    card.classList.contains("selected") &&
                    value === "date"
                ) {

                    if (!document.getElementById("customization-date")) {

                        detailsContainer.insertAdjacentHTML("beforeend", `
                            <div class="customization-detail">

                                <label for="customization-date">
                                    Quale data vuoi inserire?
                                </label>

                                <input
                                    type="date"
                                    id="customization-date"
                                    class="assistant-input"
                                >

                            </div>
                        `);

                    }

                } else if (value === "date") {

                    const field =
                        document.getElementById("customization-date");

                    if (field) {
                        field.parentElement.remove();
                    }

                }


                /* ==========================
                   DEDICA
                ========================== */

                if (
                    card.classList.contains("selected") &&
                    value === "dedication"
                ) {

                    if (
                        !document.getElementById(
                            "customization-dedication"
                        )
                    ) {

                        detailsContainer.insertAdjacentHTML("beforeend", `
                            <div class="customization-detail">

                                <label for="customization-dedication">
                                    Cosa vuoi scrivere nella dedica?
                                </label>

                                <textarea
                                    id="customization-dedication"
                                    class="assistant-textarea"
                                    placeholder="Scrivi qui la tua dedica..."
                                    rows="4"
                                ></textarea>

                            </div>
                        `);

                    }

                } else if (value === "dedication") {

                    const field =
                        document.getElementById(
                            "customization-dedication"
                        );

                    if (field) {
                        field.parentElement.remove();
                    }

                }

                /* ==========================
    FOTO
    ========================== */

    if (
    card.classList.contains("selected") &&
    value === "photo"
    ) {

    if (!document.getElementById("customization-photo")) {

        detailsContainer.insertAdjacentHTML("beforeend", `
            <div class="customization-detail">

                <label for="customization-photo-input">
                    🖼️ Carica la foto che vuoi utilizzare
                </label>

                <input
                    type="file"
                    id="customization-photo-input"
                    accept="image/jpeg,image/png,image/webp"
                    class="assistant-input"
                >

                <div
                    id="customization-photo-status"
                    style="margin-top:10px;"
                ></div>

            </div>
        `);

        const photoInput =
            document.getElementById(
                "customization-photo-input"
            );

        const photoStatus =
            document.getElementById(
                "customization-photo-status"
            );


        photoInput.addEventListener(
            "change",
            async () => {

                const file =
                    photoInput.files[0];

                if (!file) return;


                photoStatus.textContent =
                    "⏳ Caricamento della foto...";


                try {

                    const formData =
                        new FormData();

                    formData.append(
                        "file",
                        file
                    );

                    formData.append(
                        "upload_preset",
                        "universo_adele_uploads"
                    );


                    const response =
                        await fetch(
                            "https://api.cloudinary.com/v1_1/scfaz3xt/image/upload",
                            {
                                method: "POST",
                                body: formData
                            }
                        );


                    if (!response.ok) {
                        throw new Error(
                            "Upload Cloudinary fallito."
                        );
                    }


                    const data =
                        await response.json();


                    answers.photo = {
                        name: file.name,
                        url: data.secure_url
                    };


                    photoStatus.innerHTML = `
                        <div>
                            ✅ Foto caricata:
                            <strong>
                                ${file.name}
                            </strong>
                        </div>
                    `;


                    console.log(
                        "Foto caricata su Cloudinary:",
                        answers.photo
                    );


                } catch (error) {

                    console.error(
                        "Errore upload foto:",
                        error
                    );


                    photoStatus.textContent =
                        "❌ Non è stato possibile caricare la foto. Riprova.";

                    delete answers.photo;

                }

            }
        );

    }

    } else if (value === "photo") {

    const field =
        document.getElementById(
            "customization-photo"
        );

    if (field) {
        field.parentElement.remove();
    }

    delete answers.photo;
    }

    /* ==========================
    LOGO
    ========================== */

    if (
    card.classList.contains("selected") &&
    value === "logo"
    ) {

    if (!document.getElementById("customization-logo")) {

        detailsContainer.insertAdjacentHTML("beforeend", `
            <div class="customization-detail">

                <label for="customization-logo-input">
                    🏷️ Carica il tuo logo
                </label>

                <input
                    type="file"
                    id="customization-logo-input"
                    accept="image/jpeg,image/png,image/webp,image/svg+xml,application/pdf"
                    class="assistant-input"
                >

                <div
                    id="customization-logo-status"
                    style="margin-top:10px;"
                ></div>

            </div>
        `);

        const logoInput =
            document.getElementById(
                "customization-logo-input"
            );

        const logoStatus =
            document.getElementById(
                "customization-logo-status"
            );

        logoInput.addEventListener(
            "change",
            async () => {

                const file =
                    logoInput.files[0];

                if (!file) return;

                logoStatus.textContent =
                    "⏳ Caricamento del logo...";

                try {

                    const formData =
                        new FormData();

                    formData.append(
                        "file",
                        file
                    );

                    formData.append(
                        "upload_preset",
                        "universo_adele_uploads"
                    );

                    const response =
                        await fetch(
                            "https://api.cloudinary.com/v1_1/scfaz3xt/image/upload",
                            {
                                method: "POST",
                                body: formData
                            }
                        );

                    if (!response.ok) {
                        throw new Error(
                            "Upload Cloudinary fallito."
                        );
                    }

                    const data =
                        await response.json();

                    answers.logo = {
                        name: file.name,
                        url: data.secure_url
                    };

                    logoStatus.innerHTML = `
                        <div>
                            ✅ Logo caricato:
                            <strong>
                                ${file.name}
                            </strong>
                        </div>
                    `;

                    console.log(
                        "Logo caricato su Cloudinary:",
                        answers.logo
                    );

                } catch (error) {

                    console.error(
                        "Errore upload logo:",
                        error
                    );

                    logoStatus.textContent =
                        "❌ Non è stato possibile caricare il logo. Riprova.";

                    delete answers.logo;
                }

            }
        );

    }

    } else if (value === "logo") {

    const field =
        document.getElementById(
            "customization-logo"
        );

    if (field) {
        field.parentElement.remove();
    }

    delete answers.logo;
    }

                /* ==========================
                   COLORI
                ========================== */

                if (
                    card.classList.contains("selected") &&
                    value === "colors"
                ) {

                    if (
                        !document.getElementById(
                            "customization-colors"
                        )
                    ) {

                        detailsContainer.insertAdjacentHTML("beforeend", `
                            <div
                                class="customization-detail"
                                id="customization-colors"
                            >

                                <label>
                                    Quali colori preferisci?
                                </label>

                                <div class="color-palette">

                                    <button
                                        type="button"
                                        class="color-choice"
                                        data-color="Bianco"
                                    >
                                        <span
                                            class="color-dot"
                                            style="background:#ffffff;"
                                        ></span>
                                        <span>Bianco</span>
                                    </button>

                                    <button
                                        type="button"
                                        class="color-choice"
                                        data-color="Nero"
                                    >
                                        <span
                                            class="color-dot"
                                            style="background:#222222;"
                                        ></span>
                                        <span>Nero</span>
                                    </button>

                                    <button
                                        type="button"
                                        class="color-choice"
                                        data-color="Beige"
                                    >
                                        <span
                                            class="color-dot"
                                            style="background:#d8c3a5;"
                                        ></span>
                                        <span>Beige</span>
                                    </button>

                                    <button
                                        type="button"
                                        class="color-choice"
                                        data-color="Grigio"
                                    >
                                        <span
                                            class="color-dot"
                                            style="background:#9ca3af;"
                                        ></span>
                                        <span>Grigio</span>
                                    </button>

                                    <button
                                        type="button"
                                        class="color-choice"
                                        data-color="Rosso"
                                    >
                                        <span
                                            class="color-dot"
                                            style="background:#c0392b;"
                                        ></span>
                                        <span>Rosso</span>
                                    </button>

                                    <button
                                        type="button"
                                        class="color-choice"
                                        data-color="Rosa"
                                    >
                                        <span
                                            class="color-dot"
                                            style="background:#e8a0b5;"
                                        ></span>
                                        <span>Rosa</span>
                                    </button>

                                    <button
                                        type="button"
                                        class="color-choice"
                                        data-color="Arancio"
                                    >
                                        <span
                                            class="color-dot"
                                            style="background:#e67e22;"
                                        ></span>
                                        <span>Arancio</span>
                                    </button>

                                    <button
                                        type="button"
                                        class="color-choice"
                                        data-color="Giallo"
                                    >
                                        <span
                                            class="color-dot"
                                            style="background:#f1c40f;"
                                        ></span>
                                        <span>Giallo</span>
                                    </button>

                                    <button
                                        type="button"
                                        class="color-choice"
                                        data-color="Verde"
                                    >
                                        <span
                                            class="color-dot"
                                            style="background:#5b8c5a;"
                                        ></span>
                                        <span>Verde</span>
                                    </button>

                                    <button
                                        type="button"
                                        class="color-choice"
                                        data-color="Azzurro"
                                    >
                                        <span
                                            class="color-dot"
                                            style="background:#72c9e8;"
                                        ></span>
                                        <span>Azzurro</span>
                                    </button>

                                    <button
                                        type="button"
                                        class="color-choice"
                                        data-color="Blu"
                                    >
                                        <span
                                            class="color-dot"
                                            style="background:#3568a8;"
                                        ></span>
                                        <span>Blu</span>
                                    </button>

                                    <button
                                        type="button"
                                        class="color-choice"
                                        data-color="Viola"
                                    >
                                        <span
                                            class="color-dot"
                                            style="background:#8064a2;"
                                        ></span>
                                        <span>Viola</span>
                                    </button>

                                    <button
                                        type="button"
                                        class="color-choice"
                                        data-color="Verde salvia"
                                    >
                                        <span
                                            class="color-dot"
                                            style="background:#9caf88;"
                                        ></span>
                                        <span>Verde salvia</span>
                                    </button>

                                    <button
                                        type="button"
                                        class="color-choice"
                                        data-color="Rosa cipria"
                                    >
                                        <span
                                            class="color-dot"
                                            style="background:#d9a6a6;"
                                        ></span>
                                        <span>Rosa cipria</span>
                                    </button>

                                    <button
                                        type="button"
                                        class="color-choice"
                                        data-color="Naturale"
                                    >
                                        <span
                                            class="color-dot"
                                            style="background:#b89d7a;"
                                        ></span>
                                        <span>Naturale</span>
                                    </button>

                                    <button
                                        type="button"
                                        class="color-choice"
                                        data-color="Oro"
                                    >
                                        <span
                                            class="color-dot"
                                            style="background:#d4af37;"
                                        ></span>
                                        <span>Oro</span>
                                    </button>

                                    <button
                                        type="button"
                                        class="color-choice"
                                        data-color="Argento"
                                    >
                                        <span
                                            class="color-dot"
                                            style="background:#bfc1c2;"
                                        ></span>
                                        <span>Argento</span>
                                    </button>

                                    <button
                                        type="button"
                                        class="color-choice custom-color-choice"
                                        data-color="custom"
                                    >
                                        <span
                                            class="color-dot custom-dot"
                                        ></span>
                                        <span>
                                            Colore personalizzato
                                        </span>
                                    </button>

                                </div>

                                <p class="color-limit">
                                    Puoi scegliere fino a 3 colori
                                    dalla tavolozza.
                                </p>

                                <div
                                    id="custom-color-picker"
                                    class="custom-color-picker"
                                    style="display:none;"
                                >

                                    <label for="custom-color-input">
                                        Scegli una tonalità specifica
                                    </label>

                                    <input
                                        type="color"
                                        id="custom-color-input"
                                        value="#b89d8c"
                                    >

                                </div>

                            </div>
                        `);

                        const selectedColors = [];
                        let customColorSelected = false;

                        document
                            .querySelectorAll(
                                "#customization-colors .color-choice"
                            )
                            .forEach(colorButton => {

                                colorButton.addEventListener(
                                    "click",
                                    () => {

                                        const color =
                                            colorButton.dataset.color;


                                        /* COLORE PERSONALIZZATO */

                                        if (color === "custom") {

                                            customColorSelected =
                                                !customColorSelected;

                                            colorButton.classList.toggle(
                                                "selected",
                                                customColorSelected
                                            );

                                            const customPicker =
                                                document.getElementById(
                                                    "custom-color-picker"
                                                );

                                            if (customPicker) {

                                                customPicker.style.display =
                                                    customColorSelected
                                                        ? "block"
                                                        : "none";
                                            }

                                            return;
                                        }


                                        /* DESELEZIONA COLORE */

                                        if (
                                            colorButton.classList
                                                .contains("selected")
                                        ) {

                                            colorButton.classList.remove(
                                                "selected"
                                            );

                                            const index =
                                                selectedColors.indexOf(
                                                    color
                                                );

                                            if (index !== -1) {
                                                selectedColors.splice(
                                                    index,
                                                    1
                                                );
                                            }

                                            return;
                                        }


                                        /* MASSIMO 3 COLORI */

                                        if (
                                            selectedColors.length >= 3
                                        ) {

                                            alert(
                                                "Puoi scegliere fino a 3 colori dalla tavolozza."
                                            );

                                            return;
                                        }


                                        colorButton.classList.add(
                                            "selected"
                                        );

                                        selectedColors.push(color);

                                    }
                                );

                            });

                    }

                } else if (value === "colors") {

                    const field =
                        document.getElementById(
                            "customization-colors"
                        );

                    if (field) {
                        field.remove();
                    }

                }


                /* ==========================
                   ALTRO
                ========================== */

                if (
                    card.classList.contains("selected") &&
                    value === "other"
                ) {

                    if (
                        !document.getElementById(
                            "customization-other"
                        )
                    ) {

                        detailsContainer.insertAdjacentHTML("beforeend", `
                            <div class="customization-detail">

                                <label for="customization-other">
                                    Raccontami cosa vorresti personalizzare
                                </label>

                                <textarea
                                    id="customization-other"
                                    class="assistant-textarea"
                                    placeholder="Scrivi qui..."
                                    rows="4"
                                ></textarea>

                            </div>
                        `);

                    }

                } else if (value === "other") {

                    const field =
                        document.getElementById(
                            "customization-other"
                        );

                    if (field) {
                        field.parentElement.remove();
                    }

                }


                /* ==========================
                   LISTA SELEZIONI
                ========================== */

                if (selected.includes(value)) {

                    selected.splice(
                        selected.indexOf(value),
                        1
                    );

                } else {

                    selected.push(value);

                }

            });

        });


    /* ==========================
       CONTINUA
    ========================== */

    document
    .getElementById("customizations-next")
    .addEventListener("click", () => {

        answers.customizations = [...selected];

        // Nome
        const nameField =
            document.getElementById("customization-name");

        answers.name = nameField
            ? nameField.value.trim()
            : "";


        // Data
        const dateField =
            document.getElementById("customization-date");

        answers.customizationDate = dateField
            ? dateField.value
            : "";


        // Dedica
        const dedicationField =
            document.getElementById("customization-dedication");

        answers.dedication = dedicationField
            ? dedicationField.value.trim()
            : "";


        // Altro
        const otherField =
            document.getElementById("customization-other");

        answers.customizationOther = otherField
            ? otherField.value.trim()
            : "";


        // Colori
        const selectedColorButtons =
            document.querySelectorAll(
                "#customization-colors .color-choice.selected"
            );

        answers.colors = [];

        selectedColorButtons.forEach(button => {

            const color = button.dataset.color;

            if (color !== "custom") {
                answers.colors.push(color);
            }

        });


        // Colore personalizzato
        const customColorButton =
            document.querySelector(
                "#customization-colors .custom-color-choice.selected"
            );

        const customColorInput =
            document.getElementById("custom-color-input");

        if (customColorButton && customColorInput) {
            answers.customColor = customColorInput.value;
        } else {
            answers.customColor = "";
        }


        console.log("DATI PERSONALIZZAZIONI:", answers);

        if (editingSection) {

            editingSection = null;

            showScreen("summary");

        } else {

            showScreen("inspiration");

        }

    });

    }

    function showBudget() {

    content.innerHTML = `
        <button id="assistant-back" class="assistant-back">
            ← Indietro
        </button>

        <h2>💰 Qual è il budget che hai in mente?</h2>

        <p class="assistant-intro">
            Il budget ci aiuta a capire quali materiali, dimensioni
            e tecniche possiamo proporti.
        </p>

        <p class="assistant-screen p">
            Non limita la creatività del progetto.
        </p>

        <div class="assistant-options budget-options">

            <button
                type="button"
                class="assistant-card"
                data-value="under30">
                <strong>Fino a 30 €</strong>
            </button>

            <button
                type="button"
                class="assistant-card"
                data-value="30-50">
                <strong>30 – 50 €</strong>
            </button>

            <button
                type="button"
                class="assistant-card"
                data-value="50-100">
                <strong>50 – 100 €</strong>
            </button>

            <button
                type="button"
                class="assistant-card"
                data-value="100-200">
                <strong>100 – 200 €</strong>
            </button>

            <button
                type="button"
                class="assistant-card"
                data-value="over200">
                <strong>Oltre 200 €</strong>
            </button>

            <button
                type="button"
                class="assistant-card"
                data-value="not-decided">
                <strong>Non ho ancora deciso</strong>
            </button>

        </div>
    `;

    updateProgress(screens.budget.progress);

    document
        .getElementById("assistant-back")
        .addEventListener("click", goBack);

    const cards =
        document.querySelectorAll(".budget-options .assistant-card");

        cards.forEach(card => {

        card.addEventListener("click", () => {

            const value = card.dataset.value;

            answers.budget = value;

            cards.forEach(c =>
                c.classList.remove("selected")
            );

            card.classList.add("selected");

            console.log("BUDGET:", answers.budget);

           setTimeout(() => {

        if (editingSection) {

        editingSection = null;

        showScreen("summary");

    } else {

        showScreen("contacts");

    }

    }, 300);

        });

    });

    }

    function showContacts() {

    content.innerHTML = `
        <button id="assistant-back" class="assistant-back">
            ← Indietro
        </button>

        <h2>💌 Come possiamo ricontattarti?</h2>

        <p class="assistant-intro">
            Abbiamo quasi finito! Ora lasciaci i tuoi dati
            per poterti ricontattare e parlare insieme del tuo progetto.
        </p>

        <div class="customization-detail">

            <label for="contact-name">
                Nome e cognome
            </label>

            <input
                type="text"
                id="contact-name"
                class="assistant-input"
                placeholder="Come ti chiami?"
            >

        </div>

        <div class="customization-detail">

            <label for="contact-email">
                Email
            </label>

            <input
                type="email"
                id="contact-email"
                class="assistant-input"
                placeholder="La tua email"
            >

        </div>

        <div class="customization-detail">

            <label for="contact-phone">
                Telefono <span style="font-weight:400;">(facoltativo)</span>
            </label>

            <input
                type="tel"
                id="contact-phone"
                class="assistant-input"
                placeholder="Se preferisci essere contattata anche telefonicamente"
            >

        </div>

        <p class="assistant-time">
            I tuoi dati verranno utilizzati esclusivamente
            per ricontattarti in merito alla tua richiesta.
        </p>

        <button
            id="contacts-next"
            class="assistant-button">
            Continua
        </button>
    `;

    updateProgress(98);

    document
        .getElementById("assistant-back")
        .addEventListener("click", goBack);

    document
        .getElementById("contacts-next")
        .addEventListener("click", () => {

            const name =
                document.getElementById("contact-name").value.trim();

            const email =
                document.getElementById("contact-email").value.trim();

            const phone =
                document.getElementById("contact-phone").value.trim();

            if (!name) {

                alert("Inserisci il tuo nome e cognome.");

                return;
            }

            if (!email) {

                alert("Inserisci la tua email.");

                return;
            }

            answers.contactName = name;
            answers.email = email;
            answers.phone = phone;

            console.log("DATI CONTATTO:", answers);

            showScreen("summary");

        });

    }

    function showSummary() {

    const goalLabels = {
        gift: "🎁 Un regalo",
        event: "💍 Un evento",
        home: "🏡 Per la casa",
        pet: "🐾 Per un animale",
        business: "💼 Per la mia attività",
        other: "✨ Altra idea"
    };

    const productTypeLabels = {
        wood: "🪵 Creazione in legno",
        resin: "🫧 Creazione in resina",
        mug: "☕ Tazza personalizzata",
        mirror: "🪞 Specchio inciso",
        bottle_glasses: "🍾 Bottiglie e/o bicchieri incisi",
        paintings_drawings: "🖼️ Quadri e/o disegni",
        shopper_pouches: "👜 Shopper e borselli",
        clothing: "👕 Abbigliamento",
        accessories: "✨ Accessori personalizzati",
        magnets_souvenirs: "🧲 Calamite e souvenir",
        favors: "🎁 Bomboniere",
        invitations: "💌 Inviti / partecipazioni",
        signs_decorations: "🪧 Targhe e decorazioni",
        bags_packaging: "🎀 Sacchetti e confezioni",
        cutting_boards: "🔪 Taglieri",
        clocks: "🕐 Orologi",
        pet_tags: "🏷️ Targhette personalizzate",
        pet_accessories: "🐾 Accessori personalizzati",
        portraits_drawings: "🖼️ Ritratti e/o disegni",
        gadgets: "🎁 Gadget personalizzati",
        venue_complements: "🏠 Allestimenti e complementi per locali",
        corporate_gifts: "🎀 Regali aziendali",
        paintings_decorations: "🖼️ Quadri e/o decorazioni",
        other: "➕ Altro",
        not_sure: "💭 Non lo so ancora"
    };

    const corporateRangeLabels = {
    essential: "ESSENTIAL — Piccoli gesti, grande personalizzazione",
    classic: "CLASSIC — Idee regalo utili e personalizzate",
    prestige: "PRESTIGE — Composizioni che lasciano il segno",
    premium: "PREMIUM — Creazioni importanti per sorprendere"
    };

    const corporateRangeText =
    answers.corporateRange
        ? corporateRangeLabels[answers.corporateRange] || answers.corporateRange
        : "Nessuna fascia selezionata";

    const corporateProductsText =
    Array.isArray(answers.corporateProducts) &&
    answers.corporateProducts.length
        ? answers.corporateProducts.join(" · ")
        : "Nessuna proposta selezionata";

    const productTypes = Array.isArray(answers.productType)
        ? answers.productType
        : [];

    const productTypeList = productTypes.length
        ? productTypes
            .map(item => productTypeLabels[item] || item)
            .join(", ")
        : "Non specificato";

    const emotionLabels = {
        love: "❤️ Amore",
        joy: "😊 Gioia",
        gratitude: "🤍 Gratitudine",
        elegance: "✨ Eleganza",
        serenity: "🌿 Serenità",
        fun: "🎉 Divertimento",
        other: "💭 Non lo so ancora"
    };

    const deadlineLabels = {
        urgent: "⚡ Il prima possibile",
        week: "📅 Entro una settimana",
        month: "🗓️ Entro un mese",
        date: "📆 Data precisa",
        flexible: "🌿 Non ho fretta"
    };

    const budgetLabels = {
        under30: "Fino a 30 €",
        "30-50": "30 – 50 €",
        "50-100": "50 – 100 €",
        "100-200": "100 – 200 €",
        over200: "Oltre 200 €",
        "not-decided": "Non ho ancora deciso"
    };

    const recipientLabels = {
        woman: "👩 Donna",
        man: "👨 Uomo",
        child: "🧒 Bambino",
        couple: "💑 Coppia",
        family: "👨‍👩‍👧 Famiglia",
        teacher: "🍎 Insegnante",
        dog: "🐶 Cane",
        cat: "🐱 Gatto",
        horse: "🐴 Cavallo",
        rabbit: "🐰 Coniglio"
    };

    const occasionLabels = {
    wedding: "💍 Matrimonio",
    baptism: "👶 Battesimo",
    communion: "🙏 Comunione",
    birthday: "🎂 Compleanno",
    anniversary: "❤️ Anniversario",
    retirement: "🌿 Pensionamento",
    other: "✨ Altro"
    };

    
    const safeValue = (value, fallback = "Non specificato") => {

        if (
            value === undefined ||
            value === null ||
            value === ""
        ) {
            return fallback;
        }

        return value;
    };

    const customizations = answers.customizations || [];

    const customizationLabels = {
        name: "👤 Nome",
        date: "📅 Data",
        dedication: "💌 Dedica",
        photo: "🖼️ Foto",
        logo: "🏷️ Logo",
        colors: "🎨 Colori preferiti",
        other: "✨ Altro"
    };


    const customizationList = customizations.length
        ? customizations
            .map(item => customizationLabels[item] || item)
            .join(", ")
        : "Nessuna personalizzazione";


    const colorsList =
        answers.colors && answers.colors.length
            ? answers.colors.join(" · ")
            : "";


    const customColor =
        answers.customColor || "";


    let colorsText = colorsList;

    if (customColor) {

        colorsText += colorsText
            ? ` · Personalizzato (${customColor})`
            : `Personalizzato (${customColor})`;

    }


    const recipient =
    answers.goal === "event"
        ? occasionLabels[answers.recipient] || safeValue(answers.recipient)
        : recipientLabels[answers.recipient] || safeValue(answers.recipient);


    content.innerHTML = `
        <button
            id="assistant-back"
            class="assistant-back">
            ← Indietro
        </button>

        <h2>✨ Controlla il tuo progetto</h2>

        <p class="assistant-intro">
            Ecco cosa abbiamo raccolto insieme.
            Puoi modificare qualsiasi sezione prima di inviare la richiesta.
        </p>


        <!-- PROGETTO -->

        <div class="summary-section">

            <div class="summary-section-header">
                <h3>✨ Il tuo progetto</h3>
            </div>


            <!-- COSA STAI CERCANDO -->

            <div class="summary-item summary-editable">

                <div class="summary-item-top">
                    <span>Cosa stai cercando</span>

                    <button
                        type="button"
                        class="summary-edit"
                        data-edit="question1">
                        Modifica
                    </button>
                </div>

                <strong>
                    ${safeValue(goalLabels[answers.goal])}
                </strong>

            </div>


            <!-- TIPO DI PRODOTTO -->

            <div class="summary-item summary-editable">

                <div class="summary-item-top">
                    <span>Tipo di prodotto</span>

                    <button
                        type="button"
                        class="summary-edit"
                        data-edit="productType">
                        Modifica
                    </button>
                </div>

                <strong>
                    ${productTypeList}
                </strong>

            </div>


            <!-- PER CHI -->

            ${
                answers.goal !== "home" && answers.goal !== "business"
                    ? `
                        <div class="summary-item summary-editable">

                            <div class="summary-item-top">

                                <span>Per chi</span>

                                <button
                                    type="button"
                                    class="summary-edit"
                                    data-edit="recipient">
                                    Modifica
                                </button>

                            </div>

                            <strong>
                                ${recipient}
                            </strong>

                        </div>
                    `
                    : ""
            }


            <!-- EMOZIONI -->

            <div class="summary-item summary-editable">

                <div class="summary-item-top">
                    <span>Emozioni</span>

                    <button
                        type="button"
                        class="summary-edit"
                        data-edit="emotion">
                        Modifica
                    </button>
                </div>

                <strong>
                    ${
                        Array.isArray(answers.emotion) && answers.emotion.length
                            ? answers.emotion
                                .map(item => emotionLabels[item] || item)
                                .join(" · ")
                            : "Non specificato"
                    }
                </strong>

            </div>

            ${
    answers.goal === "business"
        ? `
           

                <div class="summary-section-header corporate-section-header">
                    <h3>💼 Proposta aziendale</h3>
                </div>

                <div class="summary-item summary-editable">

                    <div class="summary-item-top">
                        <span>Fascia scelta</span>

                        <button
                            type="button"
                            class="summary-edit"
                            data-edit="corporateRange">
                            Modifica
                        </button>
                    </div>

                    <strong>
                        ${corporateRangeText}
                    </strong>

                </div>

                <div class="summary-item summary-editable">

                    <div class="summary-item-top">
                        <span>Proposte che ti interessano</span>

                        <button
                            type="button"
                            class="summary-edit"
                            data-edit="corporateProducts">
                            Modifica
                        </button>
                    </div>

                    <strong>
                        ${corporateProductsText}
                    </strong>

                </div>

            
        `
        : ""
}
            <!-- LA TUA IDEA -->

            <div class="summary-item summary-editable">

                <div class="summary-item-top">
                    <span>La tua idea</span>

                    <button
                        type="button"
                        class="summary-edit"
                        data-edit="story">
                        Modifica
                    </button>
                </div>

                <strong>
                    ${safeValue(answers.story)}
                </strong>

            </div>

        </div>


        <!-- TEMPISTICHE -->

        <div class="summary-section">

            <div class="summary-section-header">
                <h3>📅 Tempistiche</h3>

                <button
                    type="button"
                    class="summary-edit"
                    data-edit="deadline">
                    Modifica
                </button>
            </div>


            <div class="summary-item">

                <span>Quando ti serve</span>

                <strong>
                    ${safeValue(
                        deadlineLabels[answers.deadline]
                    )}
                </strong>

            </div>


            ${
                answers.deadline === "date" &&
                answers.deadlineDate
                    ? `
                        <div class="summary-item">

                            <span>Data richiesta</span>

                            <strong>
                                ${answers.deadlineDate}
                            </strong>

                        </div>
                    `
                    : ""
            }

        </div>


        <!-- PERSONALIZZAZIONI -->

        <div class="summary-section">

            <div class="summary-section-header">
                <h3>🎨 Personalizzazioni</h3>

                <button
                    type="button"
                    class="summary-edit"
                    data-edit="customizations">
                    Modifica
                </button>
            </div>


            <div class="summary-item">

                <span>Richieste</span>

                <strong>
                    ${customizationList}
                </strong>

            </div>


            ${
            answers.photo
                ? `
                    <div class="summary-item">
                        <span>🖼️ Foto</span>
                        <strong>
                            <a
                                href="${answers.photo.url}"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                ${answers.photo.name}
                            </a>
                            ✓
                        </strong>
                    </div>
                `
                : ""
            }

            ${
            answers.logo
                ? `
                    <div class="summary-item">
                        <span>🏷️ Logo</span>
                        <strong>
                            <a
                                href="${answers.logo.url}"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                ${answers.logo.name}
                            </a>
                            ✓
                        </strong>
                    </div>
                `
                : ""
            }

            ${
                answers.name
                    ? `
                        <div class="summary-item">

                            <span>Nome</span>

                            <strong>
                                ${answers.name}
                            </strong>

                        </div>
                    `
                    : ""
            }


            ${
                answers.customizationDate
                    ? `
                        <div class="summary-item">

                            <span>Data</span>

                            <strong>
                                ${answers.customizationDate}
                            </strong>

                        </div>
                    `
                    : ""
            }


            ${
                answers.dedication
                    ? `
                        <div class="summary-item">

                            <span>Dedica</span>

                            <strong>
                                ${answers.dedication}
                            </strong>

                        </div>
                    `
                    : ""
            }


            ${
                colorsText
                    ? `
                        <div class="summary-item">

                            <span>Colori</span>

                            <strong>
                                ${colorsText}
                            </strong>

                        </div>
                    `
                    : ""
            }


            ${
                answers.customizationOther
                    ? `
                        <div class="summary-item summary-story">

                            <span>Altro</span>

                            <strong>
                                ${answers.customizationOther}
                            </strong>

                        </div>
                    `
                    : ""
            }

        </div>


        <!-- ISPIRAZIONE -->

        <div class="summary-section">

            <div class="summary-section-header">

                <h3>🌿 Ispirazione</h3>

                <button
                    type="button"
                    class="summary-edit"
                    data-edit="inspiration">
                    Modifica
                </button>

            </div>


            <div class="summary-item">

                <span>Tematiche scelte</span>

                <strong>
                    ${
                        answers.inspiration &&
                        answers.inspiration.length
                            ? answers.inspiration.join(", ")
                            : "Nessuna preferenza"
                    }
                </strong>

            </div>

        </div>


        <!-- BUDGET -->

        <div class="summary-section">

            <div class="summary-section-header">

                <h3>💰 Budget</h3>

                <button
                    type="button"
                    class="summary-edit"
                    data-edit="budget">
                    Modifica
                </button>

            </div>


            <div class="summary-item">

                <span>Budget indicativo</span>

                <strong>
                    ${safeValue(
                        budgetLabels[answers.budget]
                    )}
                </strong>

            </div>

        </div>


        <!-- CONTATTI -->

        <div class="summary-section">

            <div class="summary-section-header">

                <h3>💌 I tuoi contatti</h3>

                <button
                    type="button"
                    class="summary-edit"
                    data-edit="contacts">
                    Modifica
                </button>

            </div>


            <div class="summary-item">

                <span>Nome</span>

                <strong>
                    ${safeValue(answers.contactName)}
                </strong>

            </div>


            <div class="summary-item">

                <span>Email</span>

                <strong>
                    ${safeValue(answers.email)}
                </strong>

            </div>


            ${
                answers.phone
                    ? `
                        <div class="summary-item">

                            <span>Telefono</span>

                            <strong>
                                ${answers.phone}
                            </strong>

                        </div>
                    `
                    : ""
            }

        </div>


        <button
            id="summary-submit"
            class="assistant-button">
            ✨ Invia la richiesta
        </button>

    `;


    updateProgress(100);


    /* ==========================
       INDIETRO
    ========================== */

    document
        .getElementById("assistant-back")
        .addEventListener("click", goBack);


    /* ==========================
       MODIFICA SEZIONI
    ========================== */

    document
        .querySelectorAll(".summary-edit")
        .forEach(button => {

            button.addEventListener("click", () => {

                const destination =
                    button.dataset.edit;
                
                    editingSection = destination;

                showScreen(destination);

            });

        });


    /* ==========================
    INVIO RICHIESTA SHOPIFY
    ========================== */

    document
    .getElementById("summary-submit")
    .addEventListener("click", () => {

        const contactForm =
            document.getElementById("contact_form");

        if (!contactForm) {

            alert(
                "Si è verificato un problema con l'invio. Riprova tra poco."
            );

            console.error(
                "Form Shopify contact_form non trovato."
            );

            return;
        }


        /* ==========================
           DATI CLIENTE
        ========================== */

        const emailField =
            contactForm.querySelector(
                '[name="contact[email]"]'
            );

        if (emailField) {
            emailField.value = answers.email || "";
        }


        const nameField =
            contactForm.querySelector(
                '[name="contact[first_name]"]'
            );

        if (nameField) {
            nameField.value = answers.contactName || "";
        }


        const phoneField =
            contactForm.querySelector(
                '[name="contact[phone]"]'
            );

        if (phoneField) {
            phoneField.value = answers.phone || "";
        }


        /* ==========================
           TRADUZIONE DATI
        ========================== */

        const goalText =
            goalLabels[answers.goal] ||
            safeValue(answers.goal);
        
        const productTypeText =
            Array.isArray(answers.productType) &&
            answers.productType.length
            ? answers.productType
            .map(item => productTypeLabels[item] || item)
            .join(" · ")
            : "Non specificato";

        const recipientText =
            recipientLabels[answers.recipient] ||
            safeValue(answers.recipient);

        const emotionText =
            Array.isArray(answers.emotion) && answers.emotion.length
            ? answers.emotion
            .map(item => emotionLabels[item] || item)
            .join(" · ")
            : "Non specificato";

        const deadlineText =
            deadlineLabels[answers.deadline] ||
            safeValue(answers.deadline);

        const budgetText =
            budgetLabels[answers.budget] ||
            safeValue(answers.budget);

        const corporateRangeText =
            answers.corporateRange
            ? corporateRanges[answers.corporateRange]?.label || answers.corporateRange
            : "Non specificata";

        const corporateProductsText =
            Array.isArray(answers.corporateProducts) &&
            answers.corporateProducts.length
                ? answers.corporateProducts.join(" · ")
                : "Nessuna proposta selezionata";

        const customizationsText =
            customizations.length
                ? customizations
                    .map(item =>
                        customizationLabels[item] || item
                    )
                    .join(" · ")
                : "Nessuna personalizzazione";


        /* ==========================
           ISPIRAZIONE
        ========================== */

        const inspirationLabels = {
            mare: "🌊 Mare",
            natura: "🌿 Natura",
            animali: "🐾 Animali",
            fiori: "🌸 Fiori",
            montagna: "🏔️ Montagna",
            vino: "🍷 Vino",
            birra: "🍺 Birra",
            musica: "🎵 Musica",
            cucina: "🍳 Cucina",
            viaggi: "✈️ Viaggi",
            altro: "✨ Altro",
            non_so: "💭 Non ho ancora un'idea"
        };


        const inspirationText =
            answers.inspiration &&
            answers.inspiration.length

                ? answers.inspiration
                    .map(item =>
                        inspirationLabels[item] || item
                    )
                    .join(" · ")

                : "Nessuna preferenza";


        /* ==========================
           COLORI
        ========================== */

        const colorsText =
            answers.colors &&
            answers.colors.length

                ? answers.colors.join(" · ")

                : "Nessun colore specificato";


        const customColorText =
            answers.customColor
                ? `Personalizzato (${answers.customColor})`
                : "";


        const finalColorsText =
            customColorText
                ? `${colorsText} · ${customColorText}`
                : colorsText;


        /* ==========================
           RICHIESTA COMPLETA
        ========================== */

        const requestBody = `

    NUOVA RICHIESTA DI PERSONALIZZAZIONE
    L'UNIVERSO DI ADELE
    ====================================

    👤 DATI CLIENTE

    Nome:
    ${answers.contactName || "Non specificato"}

    Email:
    ${answers.email || "Non specificata"}

    Telefono:
    ${answers.phone || "Non specificato"}


    ✨ IL PROGETTO

    Cosa sta cercando:
    ${goalText}

    Tipo di prodotto:
    ${productTypeText}

    Per chi:
    ${recipientText}

        Emozione:
    ${emotionText}

    ${
    answers.goal === "business"
        ? `

    💼 PROPOSTA AZIENDALE

    Fascia scelta:
    ${corporateRangeText}

    Proposte che ti interessano:
    ${corporateProductsText}
`
        : ""
}


    💭 LA SUA IDEA

    ${answers.story || "Nessuna descrizione"}


    🎨 PERSONALIZZAZIONI

    ${customizationsText}
    ${
        answers.photo
            ? `
    🖼️ FOTO
    File: ${answers.photo.name}
    Apri la foto:
    ${answers.photo.url}
    `
            : ""
    }

    ${
        answers.logo
            ? `
    🏷️ LOGO
    File: ${answers.logo.name}
    Apri il logo:
    ${answers.logo.url}
    `
            : ""
    }

    Nome:
    ${answers.name || "—"}

    Data:
    ${answers.customizationDate || "—"}

    Dedica:
    ${answers.dedication || "—"}

    Colori:
    ${finalColorsText}

    Altro:
    ${answers.customizationOther || "—"}


    🌿 ISPIRAZIONE

    ${inspirationText}


    📅 TEMPISTICHE

    ${deadlineText}

    Data richiesta:
    ${answers.deadlineDate || "—"}


    💰 BUDGET

    ${budgetText}


    ====================================
    Richiesta inviata dal wizard
    L'Universo di Adele
    `;


        /* ==========================
           MESSAGGIO SHOPIFY
        ========================== */

        const bodyField =
            contactForm.querySelector(
                '[name="contact[body]"]'
            );

        if (bodyField) {
            bodyField.value = requestBody;
        }


        console.log(
            "INVIO RICHIESTA SHOPIFY:",
            answers
        );


        /* ==========================
           CAPTCHA SHOPIFY
        ========================== */

        if (
            window.Shopify &&
            window.Shopify.captcha &&
            typeof window.Shopify.captcha.protect === "function"
        ) {

            window.Shopify.captcha.protect(
    contactForm,
    async () => {

        const iframe = document.createElement("iframe");

    iframe.name = "shopify-contact-submit";
    iframe.style.display = "none";

    document.body.appendChild(iframe);

    iframe.onload = () => {
        showConfirmation();
    };

    contactForm.target = "shopify-contact-submit";

    contactForm.submit();

        }
    );

        } else {

            console.error(
                "Shopify CAPTCHA non disponibile."
            );

            alert(
                "Non è stato possibile preparare l'invio. Ricarica la pagina e riprova."
            );

        }

    });
    }   

    function showConfirmation() {

    const content =
        document.getElementById("assistant-content");

    if (!content) return;

    content.innerHTML = `

        <div class="pw-wrapper confirmation-screen">

            <div class="confirmation-icon">
                ❤️
            </div>

            <h2>
                Grazie per la tua richiesta!
            </h2>

            <p>
                Ho ricevuto tutte le informazioni
                sulla tua idea.
            </p>

            <p>
                La tua richiesta è stata inviata
                correttamente.
            </p>

            <p>
                Ti ricontatterò personalmente per
                definire insieme tutti i dettagli
                della tua creazione.
            </p>

            <div class="confirmation-actions">

                <a
                    href="${window.Shopify?.routes?.root || "/"}"
                    class="button"
                >
                    Torna al negozio
                </a>

            </div>

        </div>

    `;
    }

    function showDeadlineDate() {

    
    content.innerHTML = `
        <button id="assistant-back" class="assistant-back">
            <span>←</span>
            <span>Torna indietro</span>
        </button>

        <h2>Quando ti servirebbe?</h2>

        <p class="assistant-intro">
            Seleziona la data desiderata.
        </p>

        <input
            type="date"
            id="assistant-deadline-date"
            class="assistant-input"
        >

        <button
            id="deadline-next"
            class="assistant-button"
        >
            Continua
        </button>
    `;

    updateProgress(screens.deadline.progress);

    document
        .querySelector(".assistant-back")
        .addEventListener("click", goBack);

    document
        .getElementById("deadline-next")
        .addEventListener("click", () => {

            answers.deadlineDate =
                document.getElementById("assistant-deadline-date").value;

            console.log(answers);

            if (editingSection) {
                editingSection = null;
                showScreen("summary");
            } else {
                showScreen("budget");
            }

        });

    }

    function showScreen(name, fromBrowser = false) {

    if (!fromBrowser && currentScreen !== name) {
        window.history.pushState(
            { wizardScreen: name },
            "",
            window.location.href
        );
    }

    currentScreen = name;

    const screen = screens[name];

    if (!screen) return;

    window.scrollTo({
        top: 0,
        behavior: "instant"

    

     });

    // ==========================
    // TIPO DI PRODOTTO
    // ==========================

    // ==========================
    // TIPO DI PRODOTTO
    // ==========================

    if (name === "productType") {

    const productTypeData = {

        gift: {
            title: "Che tipo di prodotto hai in mente?",
            options: [
                { value: "wood", label: "🪵 Creazione in legno" },
                { value: "resin", label: "🫧 Creazione in resina" },
                { value: "mug", label: "☕ Tazza personalizzata" },
                { value: "mirror", label: "🪞 Specchio inciso" },
                { value: "bottle_glasses", label: "🍾 Bottiglie e/o bicchieri incisi" },
                { value: "paintings_drawings", label: "🖼️ Quadri e/o disegni" },
                { value: "shopper_pouches", label: "👜 Shopper e borselli" },
                { value: "clothing", label: "👕 Abbigliamento" },
                { value: "accessories", label: "✨ Accessori personalizzati" },
                { value: "magnets_souvenirs", label: "🧲 Calamite e souvenir" },
                { value: "other", label: "➕ Altro" },
                { value: "not_sure", label: "💭 Non lo so ancora" }
            ]
        },

        event: {
            title: "Che tipo di prodotto hai in mente?",
            options: [
                { value: "favors", label: "🎁 Bomboniere" },
                { value: "invitations", label: "💌 Inviti / partecipazioni" },
                { value: "magnets_souvenirs", label: "🧲 Calamite e souvenir" },
                { value: "signs_decorations", label: "🪧 Targhe e decorazioni" },
                { value: "bottle_glasses", label: "🥂 Bottiglie e/o bicchieri incisi" },
                { value: "bags_packaging", label: "🎀 Sacchetti e confezioni" },
                { value: "resin", label: "🫧 Creazioni in resina" },
                { value: "paintings_drawings", label: "🖼️ Quadri e/o disegni" },
                { value: "accessories", label: "✨ Accessori personalizzati" },
                { value: "other", label: "➕ Altro" },
                { value: "not_sure", label: "💭 Non lo so ancora" }
            ]
        },

        home: {
            title: "Che tipo di prodotto hai in mente?",
            options: [
                { value: "wood", label: "🪵 Creazione in legno" },
                { value: "cutting_boards", label: "🔪 Taglieri" },
                { value: "mirror", label: "🪞 Specchi incisi" },
                { value: "bottle_glasses", label: "🍾 Bottiglie e/o bicchieri incisi" },
                { value: "paintings_drawings", label: "🖼️ Quadri e/o disegni" },
                { value: "resin", label: "🫧 Creazioni in resina" },
                { value: "signs_decorations", label: "🪧 Targhe e decorazioni" },
                { value: "clocks", label: "🕐 Orologi" },
                { value: "other", label: "➕ Altro" },
                { value: "not_sure", label: "💭 Non lo so ancora" }
            ]
        },

        pet: {
            title: "Che tipo di prodotto hai in mente?",
            options: [
                { value: "wood", label: "🪵 Creazioni in legno" },
                { value: "pet_tags", label: "🏷️ Targhette personalizzate" },
                { value: "pet_accessories", label: "🐾 Accessori personalizzati" },
                { value: "portraits_drawings", label: "🖼️ Ritratti e/o disegni" },
                { value: "resin", label: "🫧 Creazioni in resina" },
                { value: "other", label: "➕ Altro" },
                { value: "not_sure", label: "💭 Non lo so ancora" }
            ]
        },

        business: {
            title: "Che tipo di prodotto hai in mente?",
            options: [
                { value: "gadgets", label: "🎁 Gadget personalizzati" },
                { value: "magnets_souvenirs", label: "🧲 Calamite e souvenir" },
                { value: "wood", label: "🪵 Creazioni in legno" },
                { value: "resin", label: "🫧 Creazioni in resina" },
                { value: "venue_complements", label: "🏠 Allestimenti e complementi per locali" },
                { value: "clothing", label: "👕 Abbigliamento personalizzato" },
                { value: "shopper_pouches", label: "👜 Shopper e borselli" },
                { value: "bottle_glasses", label: "🥂 Bottiglie e/o bicchieri incisi" },
                { value: "paintings_decorations", label: "🖼️ Quadri e/o decorazioni" },
                { value: "corporate_gifts", label: "🎀 Regali aziendali" },
                { value: "other", label: "➕ Altro" },
                { value: "not_sure", label: "💭 Non lo so ancora" }
            ]
        }

    };

    const data = productTypeData[answers.goal];

    // Recupera eventuali selezioni già effettuate
    const selectedProducts = Array.isArray(answers.productType)
        ? answers.productType
        : [];

    content.innerHTML = `
        <button id="assistant-back" class="assistant-back">
            <span>←</span>
            <span>Torna indietro</span>
        </button>

        <h2>${data.title}</h2>

        <p class="assistant-intro">
            Puoi scegliere anche più di un prodotto.
        </p>

        <div class="assistant-options">
            ${data.options.map(option => `
                <button
                    type="button"
                    class="assistant-card ${
                        selectedProducts.includes(option.value)
                            ? "selected"
                            : ""
                    }"
                    data-value="${option.value}"
                >
                    ${option.label}
                </button>
            `).join("")}
        </div>

        <button
            type="button"
            id="product-type-next"
            class="assistant-button"
            disabled
        >
            Continua
        </button>
    `;

    updateProgress(screen.progress);

    const backButton = document.getElementById("assistant-back");

    if (backButton) {
        backButton.addEventListener("click", goBack);
    }

    const cards = document.querySelectorAll(".assistant-card");
    const nextButton = document.getElementById("product-type-next");

    const selected = new Set(selectedProducts);

    function updateProductButton() {
        nextButton.disabled = selected.size === 0;
    }

    cards.forEach(card => {

        card.addEventListener("click", () => {

            const value = card.dataset.value;

            if (selected.has(value)) {

                selected.delete(value);
                card.classList.remove("selected");

            } else {

                selected.add(value);
                card.classList.add("selected");

            }

            updateProductButton();

        });

    });

    updateProductButton();

    nextButton.addEventListener("click", () => {

        answers.productType = [...selected];

        console.log("PRODOTTI SCELTI:", answers.productType);

        if (editingSection) {
            editingSection = null;
            showScreen("summary");

        } else if (
            answers.goal === "business" ||
            answers.goal === "home"
        ) {
            showScreen("emotion");

        } else {
            showScreen("recipient");
        }

    });

    return;
    }

    // ==========================
    // RECIPIENT
    // ==========================

    if (name === "recipient") {

        const data = recipientData[answers.goal];

        renderCards({
            title: data.title,
            subtitle: "Scegli l'opzione che descrive meglio il tuo progetto.",
            options: data.options,
            answerKey: "recipient",
            nextScreen: "emotion"
        });

        updateProgress(screen.progress);
        return;

    }

    // ==========================
    // EMOTION
    // ==========================

    if (name === "emotion") {

    const selectedEmotions = Array.isArray(answers.emotion)
        ? answers.emotion
        : [];

    content.innerHTML = `
        <button id="assistant-back" class="assistant-back">
            <span>←</span>
            <span>Torna indietro</span>
        </button>

        <h2>${emotionData.title}</h2>

        <p class="assistant-intro">
            Puoi scegliere anche più di un'emozione.
        </p>

        <div class="assistant-options">
            ${emotionData.options.map(option => `
                <button
                    type="button"
                    class="assistant-card ${
                        selectedEmotions.includes(option.value)
                            ? "selected"
                            : ""
                    }"
                    data-value="${option.value}"
                >
                    ${option.label}
                </button>
            `).join("")}
        </div>

        <button
            type="button"
            id="emotion-next"
            class="assistant-button"
            disabled
        >
            Continua
        </button>
    `;

    updateProgress(screen.progress);

    const backButton =
        document.getElementById("assistant-back");

    if (backButton) {
        backButton.addEventListener("click", goBack);
    }

    const cards =
        document.querySelectorAll(".assistant-card");

    const nextButton =
        document.getElementById("emotion-next");

    const selected =
        new Set(selectedEmotions);

    function updateEmotionButton() {
        nextButton.disabled = selected.size === 0;
    }

    cards.forEach(card => {

        card.addEventListener("click", () => {

            const value =
                card.dataset.value;

            if (selected.has(value)) {

                selected.delete(value);
                card.classList.remove("selected");

            } else {

                selected.add(value);
                card.classList.add("selected");

            }

            updateEmotionButton();

        });

    });

    updateEmotionButton();

    nextButton.addEventListener("click", () => {

        answers.emotion = [...selected];

        console.log(
            "EMOZIONI SCELTE:",
            answers.emotion
        );

        if (editingSection) {

            editingSection = null;
            showScreen("summary");

        } else if (answers.goal === "business") {
            showScreen("corporateRange");
        } else {
            showScreen("story");
        }

    });

    return;
    }

    // ==========================
    // CORPORATE RANGE
    // ==========================

    if (name === "corporateRange") {

    content.innerHTML = `
        <button id="assistant-back" class="assistant-back">
            <span>←</span>
            <span>Torna indietro</span>
        </button>

        <h2>Scegli la fascia più adatta alle tue esigenze</h2>

        <p class="assistant-intro">
            Abbiamo creato quattro fasce di proposta per aiutarti
            a trovare il regalo più adatto alla tua azienda.
        </p>

        <div class="assistant-options corporate-ranges">

        ${Object.entries(corporateRanges).map(([value, range]) => `

        <button
        type="button"
        class="assistant-card corporate-range-card corporate-range-${value}"
        data-value="${value}"
        >

        <img
        src="${range.presentationImage}"
        alt="Presentazione linea ${range.label}"
        class="corporate-range-image"
        >

        <strong>
        ${range.label}
        </strong>

        <span>
        ${range.subtitle}
        </span>
        </button>

        `).join("")}

        </div>
    `;

    updateProgress(70);

    document
        .getElementById("assistant-back")
        .addEventListener("click", goBack);

    document
        .querySelectorAll(".corporate-range-card")
        .forEach(card => {

            card.addEventListener("click", () => {

                answers.corporateRange =
                    card.dataset.value;

                answers.corporateProducts = [];

                showScreen("corporateProducts");

            });

        });

    return;
}

window.addEventListener("popstate", function (event) {

    if (event.state && event.state.wizardScreen) {

        browserNavigation = true;

        showScreen(event.state.wizardScreen, true);
    }
});

// ==========================
// CORPORATE PRODUCTS
// ==========================

if (name === "corporateProducts") {

    const range = corporateRanges[answers.corporateRange];

    if (!range) {
        showScreen("corporateRange");
        return;
    }

    const selectedProducts =
        Array.isArray(answers.corporateProducts)
            ? answers.corporateProducts
            : [];

    content.innerHTML = `
        <button id="assistant-back" class="assistant-back">
            <span>←</span>
            <span>Torna indietro</span>
        </button>

        <h2>Scopri le proposte ${range.label}</h2>

        <p class="assistant-intro">
            ${range.description}
        </p>

        <p class="assistant-intro">
            Puoi scegliere una o più idee da cui partire.
        </p>

        <div class="assistant-options corporate-products">

            ${range.products.map(product => `
                <button
                    type="button"
                    class="assistant-card corporate-product-card ${
                        selectedProducts.includes(product)
                            ? "selected"
                            : ""
                    }"
                    data-value="${product}"
                >
                    ${product}
                </button>
            `).join("")}

        </div>

        <button
            type="button"
            id="corporate-products-next"
            class="assistant-button"
            ${selectedProducts.length === 0 ? "disabled" : ""}
        >
            Continua
        </button>
    `;

    updateProgress(75);

    document
        .getElementById("assistant-back")
        .addEventListener("click", goBack);

    const cards =
        document.querySelectorAll(".corporate-product-card");

    const nextButton =
        document.getElementById("corporate-products-next");

    const selected =
        new Set(selectedProducts);

    function updateCorporateProductsButton() {
        nextButton.disabled = selected.size === 0;
    }

    cards.forEach(card => {

        card.addEventListener("click", () => {

            const value = card.dataset.value;

            if (selected.has(value)) {

                selected.delete(value);
                card.classList.remove("selected");

            } else {

                selected.add(value);
                card.classList.add("selected");

            }

            updateCorporateProductsButton();

        });

    });

    updateCorporateProductsButton();

    nextButton.addEventListener("click", () => {

        answers.corporateProducts = [...selected];

        console.log(
            "PRODOTTI AZIENDALI SCELTI:",
            answers.corporateProducts
        );

        if (editingSection) {

            editingSection = null;
            showScreen("summary");

        } else {

            showScreen("story");

        }

    });

    return;
}

    if (name === "deadline") {

    renderCards({

        title: deadlineData.title,

        subtitle: "Scegli l'opzione più adatta.",

        options: deadlineData.options,

        answerKey: "deadline",

        nextScreen: "customizations",
        extraContent: `
    <div id="deadline-extra"></div>
    `

    });

    updateProgress(screen.progress);

    return;
    }

        const corporateProductImages = {

    "Calamita in legno":
        "URL_CALAMITE",

    "Portachiavi in legno":
        "URL_PORTACHIAVI",

    "Segnalibro in legno":
        "URL_SEGNALIBRI",
    
    "Segnalibro in metallo sublimabile":
        "URL_SEGNALIBRI",

    "Sottobicchiere in sughero":
        "URL_SOTTOBICCHIERI",

    "Apribottiglie":
        "URL_CAVATAPPI"

};
    // ==========================
    // CUSTOMIZATIONS
    // ==========================

    if (name === "customizations") {

        showCustomizations();

        return;

    }

    if (name === "inspiration") {

        content.innerHTML = screen.html;

        window.scrollTo({
        top: 0,
        behavior: "instant"
    });

    updateProgress(screen.progress);

    document
    .getElementById("assistant-back")
    .addEventListener("click", goBack);

    const inspirationList = document.getElementById("inspiration-list");

    inspirationList.innerHTML = inspirationOptions.map(option => `
        <button
            type="button"
            class="assistant-card inspiration-card"
            data-value="${option.value}">

            <img
                src="${option.image}"
                alt="${option.label}"
                class="inspiration-image">

            <span class="inspiration-label">
                ${option.label}
            </span>

        </button>
    `).join("");

    const selected = [];

    document.querySelectorAll(".inspiration-card").forEach(card => {

        card.addEventListener("click", () => {

            const value = card.dataset.value;

            card.classList.toggle("selected");

            if (selected.includes(value)) {

                selected.splice(selected.indexOf(value), 1);

            } else {

                selected.push(value);

            }

        });

    });

    document
        .getElementById("inspiration-next")
        .addEventListener("click", () => {

            answers.inspiration = [...selected];

            console.log(answers);

           if (editingSection) {
                editingSection = null;
                showScreen("summary");
            } else {
                showScreen("budget");
            }

        });

    return;

    }

    if (name === "budget") {

        showBudget();

        return;

    }

    if (name === "contacts") {

        showContacts();

        return;

    }

    if (name === "summary") {

        showSummary();

        return;

    }

    // ==========================
    // STORY
    // ==========================

    if (name === "story") {

    content.innerHTML = `
        <button id="assistant-back" class="assistant-back">
            ← Indietro
        </button>

        ${screen.html}
    `;

    const storyTextarea = document.getElementById("assistant-story");

    if (storyTextarea && answers.story) {
        storyTextarea.value = answers.story;
    }
    updateProgress(screen.progress);

    const backButton = document.getElementById("assistant-back");

    if (backButton) {
        backButton.addEventListener("click", goBack);
    }

    const nextButton = document.getElementById("story-next");

    if (nextButton) {

        nextButton.addEventListener("click", () => {

            const textarea = document.getElementById("assistant-story");

            answers.story = textarea.value;

            if (editingSection) {

                editingSection = null;

                showScreen("summary");

            } else {

                showScreen("deadline");

            }

        });

    }

    return;

    }

    // ==========================
    // SCHERMATE STATICHE
    // ==========================

    content.innerHTML = screen.html;

    updateProgress(screen.progress);

    if (name === "welcome") {

        const startButton = document.getElementById("assistant-start");

        if (startButton) {

            startButton.addEventListener("click", () => {

                showScreen("question1");

            });

        }

    }

    if (name === "question1") {

        activateCards("goal", "productType");

    }

    }

    function goBack() {

    if (window.history.state && window.history.state.wizardScreen) {
        window.history.back();
        return;
    }

    const previous = previousScreen[currentScreen];

    if (previous) {
        showScreen(previous);
    }
}
    
    showScreen("welcome");

    });